import { render, staticRenderFns } from "./createProduct.vue?vue&type=template&id=867a99e0&scoped=true&"
import script from "./createProduct.vue?vue&type=script&lang=js&"
export * from "./createProduct.vue?vue&type=script&lang=js&"
import style0 from "./createProduct.vue?vue&type=style&index=0&id=867a99e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867a99e0",
  null
  
)

export default component.exports